import { render, staticRenderFns } from "./AddUpdateAssets.vue?vue&type=template&id=6ce39fce"
import script from "./AddUpdateAssets.vue?vue&type=script&lang=js"
export * from "./AddUpdateAssets.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateAssets.vue?vue&type=style&index=0&id=6ce39fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports